import React from "react"
import styled from "styled-components"

const Container = styled.div<{ width: string, $isError?: boolean, $disabled?: boolean }>`
  width: ${props => props.width};
  border: 1px solid ${props => props.$isError ? props.theme.colors.danger : props.theme.colors.gray_300};
  border-radius: 6px;
  background-color: ${props => props.$disabled ? props.theme.colors.gray_200 : 'transparent'};
`

const Label = styled.span<{ $isError?: boolean }>`
  font-weight: 700;
  font-size: 10px;
  margin-top: 7px;
  margin-left: 12px;
  color: ${props => props.$isError ? props.theme.colors.danger : props.theme.colors.gray_500};
`

const Input = styled.input`
  background-color: transparent;
  border: none;
  font-size: 16px;
  font-weight: 600;
  width: 90%;
  outline: none;
  margin-left: 12px;
  margin-bottom: 7px;
  color: ${props => props.theme.colors.gray_900};

  &:disabled {
    color: ${props => props.theme.colors.gray_500};
    cursor: not-allowed;
  }
`

export default function InputWithLabel({ label, width, value, onInput, isPassword, isError, autoFocus, placeholder, onKeyDown, disabled, inputMode }: { label: string, width: string, value: string, onInput: (value: string) => void, isPassword?: boolean, isError?: boolean, autoFocus?: boolean, placeholder?: string, onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void, disabled?: boolean, inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'] }) {
  return (
    <Container width={width} $isError={isError} $disabled={disabled}>
      <Label $isError={isError}>{label}</Label>
      <Input disabled={disabled} autoFocus={autoFocus} type={isPassword ? 'password' : 'text'} inputMode={inputMode} value={value} placeholder={placeholder} onInput={(e) => onInput((e.target as HTMLInputElement).value)} onKeyDown={onKeyDown} />
    </Container>
  )
}